import { activeCurrencyByDate } from "../../Helpers/CurrencyConverter";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

export const storeStockServices = {
  handlePrint,
};

async function handlePrint(arrayData, reportTag, translator) {
  let dataArrayPdf = [];
  var counter = 1;
  var dataRowHeader = [];

  dataRowHeader.push(
    {
      text: translator("Naziv proizvoda"),
      fontSize: 12,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("Naziv grupe"),
      fontSize: 12,
      alignment: "left",
      bold: true,
    },
    {
      text: translator("PDV "),
      fontSize: 11,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Jed mjere"),
      fontSize: 11,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Ulaz kol"),
      fontSize: 11,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Izlaz kol"),
      fontSize: 11,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Stanje"),
      fontSize: 11,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Ulaz cijena"),
      fontSize: 11,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Izlaz cijena"),
      fontSize: 11,
      alignment: "right",
      bold: true,
    },
    {
      text: translator("Vrijednost"),
      fontSize: 11,
      alignment: "right",
      bold: true,
    }
  );

  dataArrayPdf.push(dataRowHeader);
  arrayData.forEach(function (sourceRow) {
    var dataRow = [];
    dataRow.push({
      text: sourceRow.productName,
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: sourceRow.productGroupName,
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: Number(sourceRow.taxRateValue),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: sourceRow.unitOfMeasureName,
      fontSize: 10,
      alignment: "left",
    });
    dataRow.push({
      text: Number(sourceRow.totalQuantityIn),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: Number(sourceRow.totalQuantityOut),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: Number(sourceRow.stockQuantity),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(reportTag.date),
      }).format(Number(sourceRow.totalPriceIn)),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(reportTag.date),
      }).format(Number(sourceRow.totalPriceOut)),
      fontSize: 10,
      alignment: "right",
    });
    dataRow.push({
      text: new Intl.NumberFormat("hr", {
        style: "currency",
        currency: activeCurrencyByDate(reportTag.date),
      }).format(Number(sourceRow.stockValue)),
      fontSize: 10,
      alignment: "right",
    });
    dataArrayPdf.push(dataRow);
    counter = counter + 1;
  });
  let dd = {
    info: {
      title: translator("InvoiceCashBalancePDF-CashBalance"),
      author: "john doe",
      subject: translator("InvoiceCashBalancePDF-CashBalance"),
    },
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [20, 130, 15, 50],
    header: [
      {
        columns: [
          {
            image:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAGACAYAAADbINq/AAAABHNCSVQICAgIfAhkiAAAAF96VFh0UmF3IHByb2ZpbGUgdHlwZSBBUFAxAAAImeNKT81LLcpMVigoyk/LzEnlUgADYxMuE0sTS6NEAwMDCwMIMDQwMDYEkkZAtjlUKNEABZgamFmaGZsZmgMxiM8FAEi2FMk61EMyAAAOwElEQVR4nO3dbYxld0HH8d//3HtnZp8Xui0tT4IBWkUxCAaDoIlColGjxIQYMMALExESgwRiggmkL/SFBiLBGDAxUuMT0ACKCWICiUXU0mKhCIViy9KW0nZn+zA7Ozs79+H4olvodra7O/femTt3/59PMm/uveec/0zunPO955x7TgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACXvjLrAXBp+kbe+cmkeVFJGc56LDCv2rSdZHTrNfnTX5/1WLj0dGc9AC5VzXMW0nvuMKNZDwTmVidNNtJfmfU4uDQJALZFSUajtBmlnfVQYG6VtClR0WyPZtYDAAB2ngAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACoUHfWA4BJtRnOeggzUVKi4YFxCQDmXMnCz16ZDEazHsjOKiXZGKV/03JEADAOAcDcajPIvt//iTzzfa+f9VBm5rbyO+nkslkPA5hDPjowx9qUPZ1ZD2KmioYHxiQAmG+LdQfA0oufV+05EMBkfHxgjrUpS9sTAO3aIKfvW85ovZ92Y5i9P/bslO7F9/LwkbWs33F/mr29NPuWsnjVkW35byvPWEhumf58gUufAGCuTSsARiuns/KFr2f1M1/P6X/7dga3raTNWpKkzXqef+z96R7Zd9HzO3nznbnnVe9Nk/1Jkib70v2pp2bva67Jvle8IAd+5pqp7H8rV+5J0k4+I6A6AoA51qbZt2eiOZz68t05/uF/z+r7b0zSSUkvJZ0zPwfPLGUhpWxtvqXXSZODafJYNLTp3/RgHrnphjycz6akyeE/e1Uue+0r073q4Njjb44sRgAA4xAAzK02wyxeeflY024cPZ7v/d5Hsvapr6bJ/jQ5MN3BbTpcUM58b38hJQtJ2jz8ts/lwbf9Uw6/5xfztLf/cpqDi1teTDm0MI3RAhVyEiBzrfS2/hY+/pH/zJ3PfXfWP3U0nTwlJb3pD+yC1yUoKVlMJ0eycu0X8q1Df5iTX/r2lhdTDvRiDwAwDgHAHGtTlraw8R60uect1+XYb/5DmhzcNV+hK1lMSS93vfRPsnzdDVub2LYfGNPuWAPCWNo0+y5yF/igzXde/6Gc+ug3p7+7/1yaLZ40kJJOnpLlN3007cmNXP6WV13cVEXDA+Ox9mCulT0X17B3v/nDZzb+k500uN2aHMzyWz+RB//uCxf1egEAjMvagznWJs2F38LHPvi5nPyrW3Z249+Ov2++k0O5/7f+Nmv/c/SCry2lE8cBgHEIAObbBd7Bp+98IMu/e/33v4+/Yy4iTM6nk0P57ks+lGycf+Neuo7iAeMRAMy1pjn/BvDeX/ubnTnm/0SjSe9O2GSY9dz/gU+f91WlYw8AMB4BwBxrU85zhZ4T//HNrP/v0ZTM4H4Bncn/tZos5aF3fDrD5ZNP+prSswcAGI8AYK6V5sk37g+8/vp0dnrX/2MueB2Ai/HotQIe+PN/ffJX9Do+/wNjEQDMrTbtk54Fv3bLd9K/677M7C0+hT0ASVLSy8q1/5XR6sY5n2+WXAgIGI8AYK49egx8s4eu/++ULO3waB5ngm8BnK2kTT8rn//auZ/tdSMAgHEIAOZYe86z4Nu1QVb/+OZdc6W/SZUs5pEP33ju5/Zuw2WMgSoIAOZa6W7eA3Dyq0fT5nSSrV6Nb4qmuOiSTtY/enuGD5/a/NxehwCA8QgA5lib0tscAKs33HbmjnszNJrmRrmkzSBrX79r0zOdfUsRAMA4BABzrE2zuHk3/9pnvpnM4qt/jzelkwAfU9LLqds2B0DTdQ4AMB4BwBxrkyfsARgcO5H+Z+9NmfVbeypfA3y8blav+8qmR90LABiXtQdzrNl0P8uN+x5Km35mevw/STrTXX5Jk8Hnj6c91T/7iaaJPQDAOAQAc6pNk8VNj67f9t3sirtcn+cKhWPOMMOs5PTdx5+wGP/CwHisPZhb57rE7/qX794dX/8bTvsQQFLSTf/Yw2c/2Mx4TwcwtwQAc2zzhn6wvJKZ7/5Ppn4S4KOa9E+cOPuRXjetQwDAGAQAc6ukk9HK6bMOgfdvXZ79CYDJlL8G+KiSTvrfOPaDBzbaDJZPzOZmR8Dc2wX7SmEcJW3a3H7oD9LtHs7Ca5+Zzg8dyPDGleyGrm235RBAL6t/fUuGx0+m/+UHsvEv92aUtTSzuuERMNcEAHOspMnejAbrOfX3tydpU7I7Lo17rgsUTWGuGd66mhO3fjFJk5ImJXu2YTlADQQAl4Bmd+z2f7xtOyxfdk3kAPNtl601AYCdIAAAoEICAAAqJAAAoEJOAmRutemnzamxpy9ZSMnSFEe0dW02Msra2NOX9NJk3xRHtFWjDLMywfQlnRya2mjGMcrJJMOxp29yILvi4lOwRQKAudSmn/3vfmkuf+MvZNQfbHn60mmyeusdWf6Nj80sAtps5ND7fy5XvOHVacf4HdI0Wb/93tz98g/MKAJG6b7gKXneF69N2+9f+OXnUpp868g708woAtqs55k3vDW9qw4n7da/ulE6ndz1sr/IaPlURADzRgAwp0bpXnUwCz98ZOw5DE6vpc1ghqvtNs2hPWkOjx8g3csPZJJPr5No06bs76U5tJic48ZMFz+f2Yz/0WUPsnT1VelecWDseXSO7MlweS1FADBnnAPA3GonvdzuNlytb8vG+NR51uTbcMnhLZn18qdhwt+hHV4CfwOqJAAAoEICAAAqJAAAoEICAAAqJAAAoEICAAAqJAAAoEICAAAqJAAAoEICAAAqJAAAoEICAAAqJACYW6XXmWz6hV1wM8zuZL9DM+HfYFKlO/+rkEnfB2Vh/v8G1GkXrAFh60oWsvqXX0r/pvvSjnNXv06T/reOpcne6Q/uIpX0svqJr2R4/2oyHOOWuE2T4fdWUmb0O5Q06d/8YL733n9ORqNkqzfFK4/NZf82jO5ih7An97z5unSeunfr40+SpmTja8dSMtsQg3EIAOZUyfDmEzl589cmmEOT2e4EazL4+P1Z+fh3J5pHmdm/cUmbQVbeccOEc1mY0njGWXYn6x87mvG2/o/Nw2qU+eSdyxwrl8DKt5npBnByZc7HH5/eqZaDVwBQIQEAABUSAABQIQEAABUSAABQIQEAABUSAABQIQEAF6OULb5+e4YBMC0CAM6rTVK2HACl02SSq8sBbDcBABdUzmzQtzDFUjcCANjNBABcQEknzVJvS9P0LjsUxwGA3UwAwHm16b7kSLLFW7529ixFAAC7mQCA82gzSu9Fl215us6+pSSjOAwA7FYCAM5rkKWXP2frky012fO6H0+b4dRHBDANAgDOo81GDrzymrGm3fcrP5I2gymPCGA6BAA8qVE6OZylq58+1tSHXvHCtFmd8pgApkMAwDm1GebhXPnZ1409h96znprD1/5SRiIA2IUEAJylTZuNjLKap/3jG3Pg5390orld9e7X5OC7XpFRHjlzOMBJgcDu0J31AGBntU84Ma/9/mNt+ulkX/a/6yW5/LdfnYXnHpnKEp/+R6/NwV99cZbf+5mcvv6OtBmkpJdH+7vkB18XLCnpTGWZABciAKhIm1zWyd43XJ20bdJ00iwspNm7mMUXPj17rn5GFp99eZoDi1Nf8v6ffn72f+z5GTxwIhv3HM/Jr9yZ/tGH0q6fzqi/kSQZndrI+gfvEAHAjhAAVKPNKAsvuyLPet+bZjaG7hUH0r3iQPb+5HM2PTdcXc/tH3x7Ojm88wMDquMcAKrSDkazHsKTGm30Zz0EoCICAHaJrd5xGGASAoBqlDHu6rejmk7cPwDYKc4BoCJN+p++P/9X3jPrgZxTm2E6OTjrYQCVEABUpskoG7MexHnYAwDsDAFAhWxkAXbxAVEAYLsIAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACokAAAgAoJAACoUHfWA+DS1KZ0OvoSJtJJk0FKZ9bj4NIkANgmgxtPZ/RISRnOeiQwrwZpO8noG7MeBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAjf4fSvCHqHFDYD0AAAAASUVORK5CYII=",
            width: 150,
            marginLeft: 0,
            marginTop: 0,
          },
          {
            text: [
              {
                text: `${translator("Stanje zalihe")} \n\n`,
                fontSize: 25,
                bold: true,
                alignment: "left",
                letterSpacing: 10,
                lineHeight: 0.5,
                marginTop: 30,
              },
              {
                text: `${translator("InvoiceCashBalancePDF-Date")} : `,
                fontSize: 14,
                bold: true,
                alignment: "left",
                letterSpacing: 10,
                lineHeight: 0.5,
                marginTop: 20,
              },
              {
                text: `${new Intl.DateTimeFormat("hr").format(
                  new Date(reportTag.date)
                )} \n\n\n`,
                fontSize: 15,
                bold: true,
                alignment: "left",
                letterSpacing: 10,
                lineHeight: 0.5,
                marginTop: 20,
              },
              {
                text: `${translator("InvoiceCashBalancePDF-Tenant")} : `,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 10,
                lineHeight: 0.5,
                marginTop: 20,
              },
              {
                text: `${reportTag.tenantName} \n\n`,
                fontSize: 13,
                bold: true,
                alignment: "left",
                letterSpacing: 10,
                lineHeight: 0.5,
                marginTop: 20,
              },
              {
                text: `${translator("Oznaka prodajnog mjesta")} : `,
                fontSize: 12,
                bold: true,
                alignment: "left",
                letterSpacing: 10,
                lineHeight: 0.5,
                marginTop: 20,
              },
              {
                text: `${reportTag.storeName}\n\n`,
                fontSize: 13,
                bold: true,
                alignment: "left",
                letterSpacing: 10,
                lineHeight: 0.5,
                marginTop: 20,
              },
            ],
            fontSize: 12,
            marginRight: 20,
            marginLeft: 20,
            marginTop: 25,
            bold: false,
            alignment: "right",
            color: "#333",
            height: 60,
            lineHeight: 0.7,
            letterSpacing: 50,
          },
        ],
      },
    ],

    content: {
      table: {
        headerRows: 1,
        widths: ["auto", "*", 40, 50, 40, 40, 40, 50, 50, 60],
        body: dataArrayPdf,
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === 1 || i === node.table.body.length ? 2 : 1;
        },
        vLineWidth: function (i, node) {
          return i === 0 || i === node.table.widths.length ? 2 : 1;
        },
        hLineColor: function (i, node) {
          return i === 0 || i === 1 || i === node.table.body.length
            ? "black"
            : "black";
        },
        vLineColor: function (i, node) {
          return i === 0 || i === node.table.widths.length ? "black" : "black";
        },
      },
    },
    footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                text:
                  `${translator("InvoiceCashBalancePDF-Page")} ` +
                  currentPage.toString() +
                  " / " +
                  pageCount,
                alignment: "right",
                style: "normalText",
                fontSize: 10,
                margin: [0, 20, 20, 0],
              },
            ],
          ],
        },
        layout: "noBorders",
      };
    },
  };
  pdfMake.createPdf(dd).open();
}
